import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppStarBrandTheme from './components/AppStarBrandTheme';
import { ThemeModeProvider, useThemeMode } from './components/ThemeModeContext';

// Build a dynamic MUI theme that respects dark/light mode from ThemeModeContext
function ThemedApp() {
  const { isDarkMode } = useThemeMode();

  const theme = React.useMemo(() => {
    return createTheme({
      ...AppStarBrandTheme,
      palette: {
        mode: isDarkMode ? 'dark' : 'light',
        ...AppStarBrandTheme.palette,
      },
      components: AppStarBrandTheme.components,
      typography: AppStarBrandTheme.typography,
      shape: AppStarBrandTheme.shape,
    });
  }, [isDarkMode]);

  return (
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeModeProvider>
    <ThemedApp />
  </ThemeModeProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
